import { render, staticRenderFns } from "./TaxonomiaActivosFijos.vue?vue&type=template&id=93bb1e62&"
import script from "./TaxonomiaActivosFijos.vue?vue&type=script&lang=js&"
export * from "./TaxonomiaActivosFijos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports